import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 15 * 60;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSecondsLeft(previous => previous > 0 ? previous - 1 : 0);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  return <div className="flex items-center justify-center gap-1.5" role="timer" aria-live="off" data-id="element-36" data-mp="1fa92vdkqxw9u">
      <TimeBox value={pad(minutes)} label="MIN" data-id="element-37" data-mp="1ad96judp87vx" />
      <span className="font-heading text-lg text-brand-green" data-id="element-38" data-mp="15dw80cdgtcdi">:</span>
      <TimeBox value={pad(seconds)} label="SEC" data-id="element-39" data-mp="15fqvnyg4fila" />
    </div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-11 flex-col items-center rounded bg-brand-navy px-1 py-1 text-white" data-id="element-40" data-mp="2zrfcy79trx8u">
      <span className="font-heading text-lg leading-none" data-id="element-41" data-mp="1c0f8rk2rwqxp">{value}</span>
      <span className="text-[8px] font-extrabold tracking-widest text-brand-green" data-id="element-42" data-mp="1gzrt9y669lx4">{label}</span>
    </div>;
}